export { Globe as default } from './Globe';
